<!-- Botón flotante -->
<div class="fab-item">
    <button class="btn-flotante" (click)="abrirDialogo()" pTooltip="Ver filtros" [tooltipPosition]="'left'">
        <i class="pi pi-filter"></i>
    </button>
</div>

<!-- Diálogo de filtros -->
<p-dialog [(visible)]="mostrarDialogo" modal header="Filtros" appendTo="body" [style]="{ width: '60%' }">
    <form [formGroup]="formulario">
        <!-- Si se usan grupos de filtros -->
        @if ((gruposDeFiltros.length || 0) > 0) {
        @for (grupo of gruposDeFiltros; let gi = $index; track $index) {
        <!-- Panel colapsable -->
        @if (grupo.colapsable) {
        <div class="mb-5">
            <p-panel [toggleable]="true" [header]="grupo.titulo" class="pt-2 p-3">
                <div class="grid grid-cols-2 md:grid-cols-3 gap-x-6 gap-y-4">
                    @for (filtro of grupo.filtros; let fi = $index; track $index) {
                    <ng-container [ngTemplateOutlet]="filtroTemplate" [ngTemplateOutletContext]="{ filtro: filtro }">
                    </ng-container>
                    }
                </div>
            </p-panel>
        </div>
        }
        @if (!grupo.colapsable) {
        <div class="grid grid-cols-2 md:grid-cols-3 gap-x-6 gap-y-4 mb-4">
            @for (filtro of grupo.filtros; let fi = $index; track $index) {
            <ng-container [ngTemplateOutlet]="filtroTemplate" [ngTemplateOutletContext]="{ filtro: filtro }">
            </ng-container>
            }
        </div>
        }
        }
        } @else {
        <div class="grid grid-cols-2 md:grid-cols-3 gap-x-6 gap-y-4">
            @for (filtro of filtros; let i = $index; track $index) {
            <ng-container [ngTemplateOutlet]="filtroTemplate" [ngTemplateOutletContext]="{ filtro: filtro }">
            </ng-container>
            }
        </div>
        }

        <!-- Fallback: si no se pasan grupos, se usa el array plano -->

        <!-- Botones -->
        <div class="md:col-span-2 flex justify-end gap-2 mt-6 buttons">
            <button pButton type="button" label="Cancelar" (click)="cerrarDialogo()"
                class="p-button-secondary"></button>
            <button pButton type="button" label="Aplicar" (click)="aplicarFiltros()"></button>
        </div>
    </form>

    <!-- Template para cada tipo de filtro -->
    <ng-template #filtroTemplate let-filtro="filtro" [formGroup]="formulario">
        <div class="flex flex-col gap-1">
            <label class="mb-1 font-medium text-sm">{{ filtro.label }}</label>

            @if (filtro.tipo === 'input') {
            <input pInputText [formControlName]="filtro.formControlName" placeholder="Ingrese..." />
            }

            @if (filtro.tipo === 'multiselect') {
            <p-multiSelect [options]="obtenerOpciones(filtro.formControlName)"
                [formControlName]="filtro.formControlName" display="chip" [appendTo]="'body'" filter
                placeholder="Seleccionar..." />
            }

            @if (filtro.tipo === 'select') {
            <p-select [showClear]="true" [options]="obtenerOpciones(filtro.formControlName)"
                [formControlName]="filtro.formControlName" [appendTo]="'body'" filter placeholder="Seleccionar..." />
            }

            @if (filtro.tipo === 'calendar') {
            <p-datepicker [formControlName]="filtro.formControlName" placeholder="Seleccione una fecha"
                dateFormat="dd/mm/yy" [iconDisplay]="'input'" [showIcon]="true" [appendTo]="'body'"
                [inputStyleClass]="'w-full'" />
            }
        </div>
    </ng-template>
</p-dialog>